// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SermonNoteFormController from "./sermon_note_form_controller"
application.register("sermon-note-form", SermonNoteFormController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)
